import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var TaxForm1099IA = function TaxForm1099IA(_ref) {
  var brand = _ref.brand;
  if ((brand === null || brand === void 0 ? void 0 : brand.based_in) === "USA") {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "EkqTdQ",
      defaultMessage: [{
        "type": 0,
        "value": "Om een belastingformulier 1099-K te kunnen ontvangen, moet je aan "
      }, {
        "children": [{
          "type": 0,
          "value": "bepaalde omzetdrempels"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " op Faire voldoen. Zodra je hebt bevestigd dat je aan deze drempels voldoet, kun je je belastingformulier 1099-K bekijken en downloaden door deze stappen te volgen:"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return CertainSaleLinkFormatting(chunks);
        },
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
      step: 1
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "VPbiI1",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Voor elektronische bezorging:"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "9JoO7p",
      defaultMessage: [{
        "type": 0,
        "value": "Als je hebt gekozen voor elektronische bezorging, kun je je belastingformulier 1099-K vinden in "
      }, {
        "children": [{
          "type": 0,
          "value": "Accountinstellingen"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " op de pagina "
      }, {
        "children": [{
          "type": 0,
          "value": "Export en belastingen"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " in het Faire-portaal. Het zal beschikbaar zijn zodra het klaar is, meestal voor 31 januari."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "export-taxes");
        },
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 2
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Bnijx1",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Voor fysieke postbezorging:"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+2dQY7",
      defaultMessage: [{
        "type": 0,
        "value": "Als je een fysiek exemplaar hebt aangevraagd, zal dit medio februari worden bezorgd. Zorg ervoor dat je belastinggegevens en wettelijke adres actueel zijn in je instellingen voor "
      }, {
        "children": [{
          "type": 0,
          "value": "Export en belastingen"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " om vertragingen te voorkomen."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "export-taxes");
        }
      }
    })))));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Qdu8Ar",
    defaultMessage: [{
      "type": 0,
      "value": "Je zult geen 1099-K van Faire ontvangen, omdat deze alleen worden verzonden naar merken die in de VS zijn gevestigd. Als je in de VS woont en denkt dat je een formulier had moeten ontvangen, neem dan hieronder contact met ons op."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var CertainSaleLinkFormatting = function CertainSaleLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("360022603552"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};